module.exports = __webpack_public_path__ + "img/left-arrow.e59ea0d6.svg";